export const AUTH_TYPE = {
  LOGIN: "LOGIN",
  SIGN_UP: "SIGN_UP",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  CHANGE_PASSWORD: "CHANGE_PASSWORD"
}

export const LoginTypeEnum = {
  password: 1,
  sms: 2
}

// 注册暂时使用 login 枚举
export const SmsSendTypeEnum = {
  login: 4,
  register: 4,
  resetPassword: 2,
  setLoginPassword: 5
}

export const AUTH_ERROR_CODE = {
  MOBILE_NOT_REGISTER: "1004",
  MOBILE_ALREADY_REGISTER: "1008"
}
